/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ThresholdsValueApiModel } from './thresholds-value';

export interface DeliveryTypeApiModel {
  /**
   * Additional customer info
   */
  additional_customer_info?: string;
  /**
   * Delivery address required
   */
  delivery_address_required?: DeliveryTypeApiModelDeliveryAddressRequiredEnum;
  /**
   * Delivery date required
   */
  delivery_date_required?: number;
  /**
   * Delivery time required
   */
  delivery_time_required?: number;
  /**
   * Delivery type ID
   */
  id?: string;
  /**
   * Values set based on thresholds
   */
  price?: Array<ThresholdsValueApiModel>;
  /**
   * Title
   */
  title?: string;
}
export enum DeliveryTypeApiModelDeliveryAddressRequiredEnum {
  None = 'none',
  Pos = 'pos',
  Customer = 'customer'
}
